export interface SectionProps {
  title?: string
  description?: string
  titleStyle?: string
  descriptionStyle?: string
  wrapperStyle?: string
  rounded?: boolean
  children: React.ReactNode
}
export default function Section({
  title,
  description,
  children,
  wrapperStyle,
  titleStyle,
  descriptionStyle,
  rounded,
}: SectionProps) {
  let style = `bg-alt shadow-xl border-0 rounded-0 text-black mx-0 px-3 py-6 sm:px-6 sm:rounded-3xl lg:px-8 ${wrapperStyle}`
  const baseTitleStyle = 'text-2xl font-bold font-serif text-neutral-800 mb-2 text-center'
  const baseDescriptionStyle = 'font-sans font-normal text-sm text-gray-700 text-center pb-3'

  if (rounded) {
    style += ' rounded-3xl'
  }

  return (
    <div className={style}>
      {title && <div className={`${baseTitleStyle} ${titleStyle}`}>{title}</div>}
      {description && <div className={`${baseDescriptionStyle} ${descriptionStyle}`}>{description}</div>}
      {children}
    </div>
  )
}
